<div *ngIf="loader" id="spinerLoader" class="container">
    <ds-loading-spinner [diameter]="100" [strokeWidth]="11" color="#b52323"></ds-loading-spinner>
</div>

<div id="addContactPerson" class="modal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    class="close close-btn"
                    aria-label="Close"
                    data-dismiss="modal"
                    type="button"
                    (click)="closeContactModel()"
                    (click)="resetForm(addContactPerson)"
                >
                    <ds-icon name="close" size="inherit"></ds-icon>
                </button>
                <h4 class="modal-title">Add Contact</h4>
            </div>
            <form #addContactPerson="ngForm" name="addContactPersonForm">
                <div class="modal-body add-edit-view">
                    <div class="member-card">
                        <div class="d-flex justify-content-between">
                            <h4 class="filter-options">Personal Details</h4>
                            <div *ngIf="isShowTemContactButton == true" class="form-check" (click)="clearContactData()">
                                <input
                                    id="exampleCheck1"
                                    class="form-check-input mr-2"
                                    name="tempContact"
                                    type="checkbox"
                                    [(ngModel)]="contact.isTemporary"
                                />
                                <label class="form-check-label" for="exampleCheck1">Temporary Contact</label>
                            </div>
                        </div>
                        <hr class="hr-class mt-0" />
                        <div class="row">
                            <div *ngIf="user.role != 'Customer Coordinator' && user.role != 'Customer Admin'" class="form-group col-md-4">
                                <Label>Select Member</Label
                                ><ds-loading-spinner
                                    *ngIf="selectMemberLoader"
                                    class="text-color ml-2"
                                    theme="inherit"
                                    [diameter]="18"
                                    [strokeWidth]="2"
                                ></ds-loading-spinner>

                                <ngx-select-dropdown
                                    id="selectMember"
                                    name="exitedMember"
                                    tabindex="0"
                                    [config]="config"
                                    [disabled]="contact.isTemporary"
                                    [multiple]="false"
                                    [options]="memberList"
                                    (change)="selectMember($event)"
                                    (click)="clickDropDown('selectMember')"
                                >
                                </ngx-select-dropdown>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>First Name</label><span class="text-danger"> * </span>
                                <input
                                    id="acontact_addFirstName"
                                    class="form-control"
                                    #firstName="ngModel"
                                    autocomplete="off"
                                    maxlength="100"
                                    name="firstName"
                                    placeholder="First Name"
                                    required
                                    type="text"
                                    [ngClass]="{ 'is-invalid': addContactPerson.submitted && firstName.invalid }"
                                    [(ngModel)]="contact.firstName"
                                />

                                <div *ngIf="addContactPerson.submitted && firstName.invalid" class="invalid-feedback">
                                    <div *ngIf="firstName.errors.required"><span style="color: red">First Name is required.</span></div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label>MI</label>
                                <input
                                    id="acontact_addMiddleName"
                                    class="form-control"
                                    #middleName="ngModel"
                                    autocomplete="off"
                                    maxlength="100"
                                    name="mName"
                                    placeholder="MI"
                                    type="text"
                                    [(ngModel)]="contact.middleName"
                                />
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Last Name</label><span class="text-danger"> * </span>
                                <input
                                    id="acontact_addLastName"
                                    class="form-control"
                                    #lastName="ngModel"
                                    autocomplete="off"
                                    maxlength="100"
                                    name="lastName"
                                    name="lName"
                                    placeholder="Last Name"
                                    required
                                    type="text"
                                    [ngClass]="{ 'is-invalid': addContactPerson.submitted && lastName.invalid }"
                                    [(ngModel)]="contact.lastName"
                                />

                                <div *ngIf="addContactPerson.submitted && lastName.invalid" class="invalid-feedback">
                                    <div *ngIf="lastName.errors.required"><span style="color: red">Last Name is required.</span></div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label>Email ID</label>
                                <input
                                    id="addContactemail"
                                    class="form-control"
                                    autocomplete="off"
                                    maxlength="50"
                                    maxlength="76"
                                    name="emailId"
                                    placeholder="Email"
                                    type="email"
                                    [(ngModel)]="contact.emailId"
                                />
                            </div>
                        </div>

                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Moblie Number</label><span class="text-danger"> * </span>
                                <input
                                    id="AddContactwork_contact_no"
                                    class="form-control"
                                    #workNumber="ngModel"
                                    maxlength="14"
                                    minlength="14"
                                    name="workNumber"
                                    pattern="\(?\d+\)?[-.\s]?\d+[-.\s]?\d+"
                                    placeholder="(xxx)-xxx xxxx"
                                    required
                                    type="text"
                                    [ngClass]="{ 'is-invalid': addContactPerson.submitted && workNumber.invalid }"
                                    [ngModel]="contact.cellNumber | phoneNumberPipe"
                                    (ngModelChange)="contact.cellNumber = $event"
                                />
                                <div *ngIf="addContactPerson.submitted && workNumber.invalid" class="invalid-feedback">
                                    <div *ngIf="workNumber.errors.required"><span style="color: red">Phone Number is required.</span></div>
                                    <div *ngIf="workNumber.errors.minlength">
                                        <span style="color: red">Phone must have 10 digits.</span>
                                    </div>
                                    <div *ngIf="workNumber.errors.pattern"><span style="color: red">Phone Number not valid.</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="member-card">
                        <h4 class="filter-options">Address Details</h4>
                        <hr class="hr-class" />
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Search Address</label>
                                <input
                                    id="autocompleteAddress"
                                    class="form-control autocomplete-addr"
                                    #pick
                                    name="searchAddr"
                                    placeholder="Search"
                                    type="text"
                                    [(ngModel)]="searchAddr"
                                    (ngModelChange)="autoSearchAddress()"
                                />
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <div class="form-group mb-0">
                                    <label>Address Type</label><span class="text-danger"> * </span>
                                    <select
                                        class="form-control"
                                        #addressType="ngModel"
                                        name="addressType"
                                        required
                                        [ngClass]="{ 'is-invalid': addContactPerson.submitted && addressType.invalid }"
                                        [(ngModel)]="contact.address.addressLocationType"
                                    >
                                        <option disabled selected [value]="null">Select Address Type</option>
                                        <option *ngFor="let item of AddressType" name="addr_type" [value]="item">
                                            {{ item }}
                                        </option>
                                    </select>
                                    <div *ngIf="addContactPerson.submitted && addressType.invalid" class="invalid-feedback">
                                        <div *ngIf="addressType.errors.required">
                                            <span style="color: red">Address Type is required.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Address</label><span class="text-danger"> * </span>
                                    <div class="radio my-0">
                                        <label>
                                            <input
                                                #pvtOrPublic="ngModel"
                                                name="pvtOrPublic"
                                                required
                                                type="radio"
                                                [value]="false"
                                                [(ngModel)]="contact.address.isGlobal"
                                            />Private</label
                                        >
                                        <label class="ml-4"
                                            ><input
                                                #pvtOrPublic="ngModel"
                                                name="pvtOrPublic"
                                                required
                                                type="radio"
                                                [value]="true"
                                                [(ngModel)]="contact.address.isGlobal"
                                            />Public</label
                                        >
                                        <div *ngIf="addContactPerson.submitted && pvtOrPublic.invalid" class="invalid-feedback">
                                            <div *ngIf="pvtOrPublic.errors.required">
                                                <span style="color: red">Field is required.</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>Street Address</label>
                                <input
                                    id="aContact_StreetAddress"
                                    class="form-control"
                                    #streetAddress="ngModel"
                                    maxlength="75"
                                    maxlength="150"
                                    name="streetAddress"
                                    placeholder="Street Address"
                                    type="text"
                                    [(ngModel)]="contact.address.streetAddress"
                                />
                            </div>
                            <div class="col-md-6">
                                <label>Zipcode</label>
                                <input
                                    id="acZipCode"
                                    class="form-control"
                                    #zipCode="ngModel"
                                    maxlength="5"
                                    minlength="3"
                                    name="Zipcode"
                                    pattern="[A-Za-z0-9]+"
                                    placeholder="Zipcode"
                                    type="text"
                                    [(ngModel)]="contact.address.zipcode"
                                />
                                <div *ngIf="addContactPerson.submitted && zipCode.invalid" class="invalid-feedback">
                                    <div *ngIf="zipCode.errors.pattern">
                                        <span style="color: red">ZipCode not valid.</span>
                                    </div>
                                    <div *ngIf="zipCode.errors.minlength">
                                        <span style="color: red">ZipCode must have 3 or 5 digits.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-md-6">
                                <label>State</label>
                                <select
                                    class="form-control"
                                    name="state"
                                    [(ngModel)]="contact.address.stateId"
                                    (change)="getCityByState(contact.address.stateId)"
                                >
                                    <option disabled selected value="">Select State</option>
                                    <option *ngFor="let item of stateList" name="state" [value]="item.stateId">
                                        {{ item?.stateName }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <label>City</label>
                                <button
                                    *ngIf="isCityButtonShow && !isShowAddCity"
                                    id="addLocationPopUp"
                                    class="plus-icon"
                                    title="Add City"
                                    type="button"
                                    (click)="isShowAddCity = true"
                                >
                                    <ds-icon name="add_circle" size="inherit"></ds-icon>
                                </button>
                                <button
                                    *ngIf="isShowAddCity"
                                    class="plus-icon"
                                    title="Cancle Add City"
                                    type="button"
                                    (click)="isShowAddCity = !isShowAddCity; cityAdd.cityName = ''"
                                >
                                    <ds-icon name="cancel" size="inherit"></ds-icon>
                                </button>
                                <div *ngIf="isShowAddCity">
                                    <form #cityform="ngForm" name="cityform">
                                        <div class="col-md-8 px-0">
                                            <input
                                                class="form-control"
                                                #city="ngModel"
                                                name="city"
                                                placeholder="Enter City Name"
                                                required
                                                type="text"
                                                [ngClass]="{ 'is-invalid': cityform.submitted && city.invalid }"
                                                [(ngModel)]="cityAdd.cityName"
                                            />
                                            <div *ngIf="cityform.submitted && city.invalid" class="invalid-feedback">
                                                <div *ngIf="city.errors.required"><span style="color: red">Enter City name.</span></div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 pr-0">
                                            <button
                                                class="flat-butt flat-info-butt flat-info-grad-butt btn-size save-btn col-md-12"
                                                type="submit"
                                                (click)="addCity()"
                                            >
                                                Save
                                            </button>
                                        </div>
                                    </form>
                                </div>
                                <select
                                    *ngIf="!isShowAddCity"
                                    class="form-control"
                                    #cityName="ngModel"
                                    name="city"
                                    [(ngModel)]="contact.address.cityId"
                                >
                                    <option disabled selected value="">Select City</option>
                                    <option *ngFor="let item of cityList" [value]="item.cityId">{{ item?.cityName }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                        data-dismiss="modal"
                        type="button"
                        (click)="closeContactModel()"
                        (click)="resetForm(addContactPerson)"
                    >
                        Cancel
                    </button>

                    <button
                        class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                        type="submit"
                        [disabled]="isSaveBtnDisabled"
                        [ngClass]="{ cursorDisabled: isSaveBtnDisabled }"
                        (click)="saveContact(contact, addContactPerson)"
                    >
                        Save Changes
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
